import { useLanguage } from "@/hooks/useLanguage";
import { CHALLENGES, bumpChallenge, useChallengesProgress } from "@/lib/challenges/viralChallenges";

export function ViralChallengesPanel() {
  const { t } = useLanguage();
  const progress = useChallengesProgress();

  return (
    <section
      aria-label={t("ch_title")}
      className="rounded-2xl border border-border/60 bg-background/70 p-4 backdrop-blur"
    >
      <div className="mb-2 flex items-center justify-between">
        <h2 className="text-sm font-bold uppercase tracking-wider text-muted-foreground">
          {t("ch_title")}
        </h2>
        <span className="text-[10px] font-bold text-muted-foreground">{t("ch_world_cup_edition")}</span>
      </div>
      <ul className="grid gap-2 md:grid-cols-2">
        {CHALLENGES.map((c) => {
          const done = progress[c.id] ?? 0;
          const pct = Math.min(100, Math.round((done / c.target) * 100));
          const complete = pct >= 100;
          return (
            <li
              key={c.id}
              className="rounded-xl border border-border/60 bg-background/60 p-3"
            >
              <div className="flex items-start gap-2">
                <span aria-hidden className="text-xl">{c.emoji}</span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2">
                    <div className="text-sm font-black">{t(c.titleKey)}</div>
                    <span className="text-[10px] font-bold text-muted-foreground tabular-nums">
                      {done}/{c.target}
                    </span>
                  </div>
                  <div className="mt-0.5 text-[11px] text-muted-foreground">{t(c.descKey)}</div>
                  <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-secondary/60">
                    <div
                      className="h-full rounded-full bg-primary transition-all duration-500"
                      style={{ width: `${pct}%` }}
                      role="progressbar"
                      aria-valuenow={pct}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    />
                  </div>
                  <div className="mt-2 flex items-center justify-between gap-2">
                    <span className="text-[10px] font-bold text-foreground/70">🎁 {c.reward}</span>
                    <button
                      onClick={() => bumpChallenge(c.id, 1)}
                      disabled={complete}
                      className="rounded-full bg-primary px-2.5 py-1 text-[10px] font-bold text-primary-foreground disabled:opacity-50"
                    >
                      {complete ? t("ch_done") : t("ch_play")}
                    </button>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
